import { styled } from '@mui/material/styles'
import Avatar from 'ui/src/components/Avatar'
import Box from 'ui/src/components/Box'
import Container from 'ui/src/components/Container'
import MarketplaceSvg from 'ui/src/assets/icons/marketplace.svg?react'

type TProfileMenu = {
  isopened: number | undefined
}

export const ReferralIcon = styled(MarketplaceSvg)`
  cursor: pointer;
  fill: ${({ theme }) => theme.palette.primary.main};
  ${props => props.theme.breakpoints.down('sm')} {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
  margin-right: ${({ theme }) => theme.spacing(5)};
`

export const StyledAvatar = styled(Avatar)`
  width: 32px;
  height: 32px;
`

export const ProfileMenu = styled('div')<TProfileMenu>`
  display: flex;
  flex-direction: column;
  position: absolute;
  visibility: ${({ isopened }) => (isopened ? 'visible' : 'hidden')};
  border-radius: 5%;
  justify-content: center;
  box-shadow: ${({ theme }) => theme.shadows[2]};
  align-items: flex-start;
  right: 0;
  top: 50px;
  width: 171px;
  height: 97px;
`

export const StyledBox = styled(Box)`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.appBar};
  background-color: #ffffff;
  box-shadow: ${({ theme }) => theme.shadows[1]};
`

export const StyledContainer = styled(Container)`
  height: 92px;
  align-items: center;
  display: flex;
  justify-content: space-between;
`
